// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__0tfzz","disabledBtn":"style_disabledBtn__Tl0dW","btnTitle":"style_btnTitle__czJv9"};